module.exports = __webpack_public_path__ + "static/media/media.f5840fda.svg";